import { DefaultRawDatum, ResponsivePie } from '@nivo/pie';
import React, { useEffect, useState } from 'react';
import { getColorsForBarometer, getDataForBarometer } from '../utils/ContentQualityUtils';

interface Props {
  score: number;
  /** Overrides the default Nivo pie margins; needed when the gauge sits in a narrow container. */
  margin?: { top: number; right: number; bottom: number; left: number };
}

const Barometer: React.FunctionComponent<Props> = (props: Props) => {
  const { score, margin } = props;

  const [data, setData] = useState<DefaultRawDatum[]>([]);
  const [colors, setColors] = useState<string[]>([]);

  useEffect(() => {
    const newData = getDataForBarometer(score);
    setData(newData);
    setColors(getColorsForBarometer(newData) as string[]);
  }, [score]);

  return (
    <ResponsivePie
      data={data}
      colors={colors}
      margin={margin ?? { top: 40, right: 80, bottom: 0, left: 80 }}
      startAngle={-90}
      endAngle={90}
      innerRadius={0.5}
      padAngle={1}
      isInteractive={false}
      enableArcLabels={false}
      enableArcLinkLabels={false}
    />
  );
};

export default Barometer;
